// utilities
import api from '@/utilities/api'
// supporting actions
export const loadFacilities = ({ commit, dispatch }, payload) => {
  dispatch('getCampgrounds')
  dispatch('getCampsites')
  dispatch('getCampsiteTypes')
  dispatch('getParkingAreas')
}
// open
export const getCampgrounds = ({ rootState, commit, dispatch }, payload) => {
  let routePrefix = rootState.person.primaryPerson ? 'private' : 'open'
  return api.request({
    method: 'get',
    endpoint: routePrefix + '/facilities/campgrounds',
    success (response) {
      commit('setCampgrounds', response.data)
    }
  })
}
export const getCampsites = ({ rootState, commit, dispatch }, payload) => {
  let routePrefix = rootState.person.primaryPerson ? 'private' : 'open'
  return api.request({
    method: 'get',
    endpoint: routePrefix + '/facilities/campsites',
    payload,
    success (response) {
      commit('setCampsites', response.data)
      dispatch('getCampsiteWeek')
    }
  })
}
export const getCampsiteTypes = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'open/facilities/campsites/types',
    payload,
    success (response) {
      commit('setCampsiteTypes', response.data)
    }
  })
}
export const getCampsiteWeek = ({ state, commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'open/facilities/campsites/week/' + state.searchCriteria.date,
    success (response) {
      commit('setCampsiteWeek', response.data)
    }
  })
}
export const getCampsiteReserver = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/people/' + payload.personID,
    success (response) {
      // commit('setCampsiteReserver', {...payload, data: response.data})
    }
  })
}
export const getParkingAreas = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'open/facilities/parkingAreas',
    success (response) {
      commit('setParkingAreas', response.data)
      dispatch('getParkingWeek')
    }
  })
}
export const getParkingWeek = ({ rootState, state, commit, dispatch }, payload) => {
  // switch between open and private routes depending on login state
  let routePrefix = rootState.person.primaryPerson ? 'private' : 'open'
  return api.request({
    method: 'get',
    endpoint: routePrefix + '/facilities/parkingAreas/week/' + state.searchCriteria.date,
    success (response) {
      commit('setParkingWeek', response.data)
    }
  })
}
export const updateCampground = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/facilities/campgrounds',
    payload,
    success (response) {
      dispatch('getCampgrounds')
    }
  })
}
// new
export const updateParkingArea = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/facilities/parkingAreas',
    payload: payload,
    success (response) {
      dispatch('getParkingAreas')
    }
  })
}
export const createParkingArea = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/facilities/parkingAreas',
    payload: payload,
    success (response) {
      dispatch('getParkingAreas')
    }
  })
}
export const deleteParkingArea = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/facilities/parkingAreas',
    payload,
    success (response) {
      dispatch('getParkingAreas')
    }
  })
}
export const updateCampsite = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/facilities/campsites',
    payload,
    success (response) {
      dispatch('getCampsites')
    }
  })
}
export const createCampsite = ({ commit, dispatch }, payload) => {
  // convert dates
  return api.request({
    method: 'post',
    endpoint: 'private/facilities/campsites',
    payload,
    success (response) {
      dispatch('getCampsites')
    }
  })
}
export const deleteCampsite = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/facilities/campsites',
    payload,
    success (response) {
      dispatch('getCampsites')
    }
  })
}
export const createCampground = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/facilities/campgrounds',
    payload,
    success (response) {
      dispatch('getCampgrounds')
    }
  })
}
export const deleteCampground = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/facilities/campgrounds',
    payload,
    success (response) {
      dispatch('getCampgrounds')
      dispatch('getCampsites')
    }
  })
}
// /new
